<template>
    <LoadingScreen v-if="getLoading()" />
    <ToastNotifications />
    <router-view />
</template>

<script setup lang="ts">
import '@src/charts/ChartjsConfig'
import { LoadingScreen, ToastNotifications } from '@src/components'
import { useCountryStore } from '@stores/countries'
import { useLanguageStore } from '@stores/languages'
import { useLoadingStore } from '@stores/loading'
import { onMounted } from 'vue'

const { getLoading } = useLoadingStore()
const languageStore = useLanguageStore()
const countryStore = useCountryStore()

onMounted(async () => {
    languageStore.loadLanguages()
    countryStore.loadCountries()
})
</script>
